var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84717 14.6534C6.84717 12.9148 6.84717 12.0455 7.19796 11.2812C7.55002 10.5169 8.20935 9.95232 9.52928 8.82058L10.8095 7.72341C13.1972 5.67886 14.3878 4.65466 15.8089 4.65466C17.23 4.65466 18.4219 5.67758 20.8082 7.72213L22.0885 8.8193C23.4071 9.95104 24.0677 10.5156 24.4185 11.2799C24.7706 12.0442 24.7706 12.9135 24.7706 14.6521V20.0816C24.7706 22.4962 24.7706 23.7022 24.0204 24.4524C23.2702 25.2026 22.0642 25.2026 19.6496 25.2026H11.9681C9.55361 25.2026 8.34762 25.2026 7.59739 24.4524C6.84717 23.7022 6.84717 22.4962 6.84717 20.0816V14.6534Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0096 25.2027V18.8015C19.0096 18.4619 18.8747 18.1363 18.6346 17.8962C18.3946 17.6561 18.0689 17.5212 17.7294 17.5212H13.8886C13.5491 17.5212 13.2235 17.6561 12.9834 17.8962C12.7433 18.1363 12.6084 18.4619 12.6084 18.8015V25.2027",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.a7e1dd7efcfe4758040be4481d843732.svg";
export { ForwardRef as ReactComponent };